import { render, staticRenderFns } from "./ChannelShippingMethodSelector.vue?vue&type=template&id=7edda498&"
import script from "./ChannelShippingMethodSelector.vue?vue&type=script&lang=js&"
export * from "./ChannelShippingMethodSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports